import { createSelector } from "@reduxjs/toolkit";
import { IStoreState } from "../../../../reducers/types";
import { filterOutSpendAndGetOffers } from "halifax";

const getAllTravelWalletOffers = (state: IStoreState) =>
  state.myTripsTravelWallet.offers;

export const getTravelWalletOffers = createSelector(
  getAllTravelWalletOffers,
  (offers) => filterOutSpendAndGetOffers(offers)
);

export const getMyTripsTravelWalletCredit = (state: IStoreState) =>
  state.myTripsTravelWallet.credit;

export const getMyTripsTravelWalletCreditBreakdown = (state: IStoreState) =>
  state.myTripsTravelWallet.creditBreakdown;

export const getRedeemedEarnOffers = (state: IStoreState) =>
  state.myTripsTravelWallet.redeemedEarnOffers;
